export default "__VITE_ASSET__b849cc83__"